import React from "react";
import { motion } from "framer-motion";
import "./About.scss";
import { images } from "../../constants";
import { AppWrap, MotionWrap } from "../../wrapper";
import resume from "../../assets/resume.pdf";

function About() {
   const downloadResume = async () => {
      window.open(resume, '_blank');
  }
   const abouts = [
      {
         title: "Full-Stack Developer",
         description:
            "Inspired full-stack web developer with experience in Ruby on Rails, React, and JavaScript. Pair programming and remote work experts. Fluent in multiple languages, frameworks, and technologies, and capable of ramping up quickly.",
         imageUrl: images.about02,
      },
      {
         title: "Mentor",
         description:
            "Mentored 10 junior web developers, providing technical support through code reviews.Proposed improvements to code organization to improve code quality and overall performance.",
         imageUrl: images.about01,
      },
      
      // {
      //    title: "Tech Content Creator",
      //    description:
      //       "Helping people with problems I've personally faced in my journey is something I love to do",
      //    imageUrl: images.resume,
      // },
   ];
   return (
      <>
         <h2 className="head-text">
            About
            <span> Me!</span>
         </h2>
         <div className="app__profiles">
            {abouts.map((about, index) => (
               <motion.div
                  className="app__profile-item"
                  key={about.title + index}
                  whileInView={{ opacity: 1 }}
                  whileHover={{ scale: 1.1 }}
                  transition={{ duration: 1, type: "tween" }}
               >
                  <img src={about.imageUrl} alt={about.title}></img>
                  <h2 className="bold-text" style={{ marginTop: 20 }}>
                     {about.title}
                  </h2>
                  <p className="p-text" style={{ marginTop: 10 }}>
                     {about.description}
                  </p>
               </motion.div>
            ))}
            <button className="btn" onClick={downloadResume}>Donwload CV</button>
         </div>
      </>
   );
}

export default AppWrap(
   MotionWrap(About, "app__about"),
   "about",
   "app__whitebg"
);
